@let view = mode() | modalMode: ModalMode.VIEW;
@let edit = mode() | modalMode: ModalMode.EDIT;
@let add = mode() | modalMode: ModalMode.ADD;
<dx-modal
  height="content"
  width="xxl"
  [label]="add ? ('artist.title.new-artist' | transloco) : ('artist.title.artist-details' | transloco)"
  headingleveloverride="4"
  (modalClosed)="close()"
  [visible]="true"
>
  <div slot="content" [formGroup]="artistForm">
    <dx-grid mq1="12/12/6-6/6-6/6-6/12" mq4="12/12/6-6/3-3-3-3/12">
      @if (add) {
        <art-drag-and-drop (uploadedImage)="uploadImage($event)"></art-drag-and-drop>
      } @else if (edit) {
        <art-image-switch-area
          (uploadedImage)="uploadImage($event)"
          [altText]="manufacturerFullName()"
          [imageUrl]="imageUrl()"
          [(showDragAndDrop)]="showDragAndDrop"
        ></art-image-switch-area>
      } @else {
        <art-bordered-image [uploadedImageUrl]="imageUrl()" [altText]="manufacturerFullName()"></art-bordered-image>
      }

      <div class="art-artist-detail-headline">
        @if (view || edit) {
          <dx-text type="h4" class="art-artist-detail-title">{{ manufacturerFullName() }}</dx-text>
        }
      </div>
      <dx-text-input
        label="{{ 'artist.first-name' | transloco }}"
        formControlName="firstName"
        required="true"
        [readonly]="view"
      ></dx-text-input>
      <dx-text-input
        label="{{ 'artist.last-name' | transloco }}"
        formControlName="lastName"
        required="true"
        [readonly]="view"
      ></dx-text-input>

      <dx-dropdown label="{{ 'artist.gender' | transloco }}" formControlName="gender" required="true" [readonly]="view">
        @for (genderOption of genderOptions; track genderOption) {
          <dx-dropdown-option
            [value]="genderOption.value"
            [label]="'artist.' + genderOption.label | transloco"
          ></dx-dropdown-option>
        }
      </dx-dropdown>
      <dx-date-input
        label="{{ 'artist.date-of-birth' | transloco }}"
        formControlName="birthDate"
        [max]="today | date: 'yyyy-MM-dd'"
        [calendarerrormessage]="dateErrorMessage() ? ('artist.' + dateErrorMessage() | transloco) : ''"
        [errormessage]="dateErrorMessage() ? ('artist.' + dateErrorMessage() | transloco) : ''"
        (valueChange)="checkDateError()"
        [readonly]="view"
      >
      </dx-date-input>
      <dx-date-input
        label="{{ 'artist.date-of-death' | transloco }}"
        formControlName="deathDate"
        [max]="today | date: 'yyyy-MM-dd'"
        [calendarerrormessage]="dateErrorMessage() ? ('artist.' + dateErrorMessage() | transloco) : ''"
        [errormessage]="dateErrorMessage() ? ('artist.' + dateErrorMessage() | transloco) : ''"
        (valueChange)="changeDeathDate($event)"
        [readonly]="view"
      >
      </dx-date-input>
      <dx-dropdown
        label="{{ 'artist.status' | transloco }}"
        formControlName="status"
        required="true"
        [readonly]="view"
        (valueChange)="checkStatusError()"
        [errormessage]="statusError() ? ('artist.error-message.dead-artist-cannot-be-active' | transloco) : ''"
      >
        @for (statusOption of statusOptions; track statusOption.label) {
          <dx-dropdown-option
            [value]="statusOption.value"
            [label]="'artist.' + statusOption.label | transloco"
          ></dx-dropdown-option>
        }
      </dx-dropdown>

      <dx-text-area
        label="{{ 'artist.biography' | transloco }}"
        formControlName="biography"
        [readonly]="view"
      ></dx-text-area>
    </dx-grid>
  </div>

  <div slot="custom-actions">
    @if (add) {
      <dx-button
        type="primary-m"
        label="{{ 'artist.button.create-artist' | transloco }}"
        class="art-submit-button"
        [disabled]="isFormBlocked"
        (click)="createArtist()"
        [loading]="isLoading()"
      ></dx-button>
    }
    @if (view) {
      <dx-button
        type="primary-m"
        label="{{ 'artist.button.edit-artist' | transloco }}"
        class="art-submit-button"
        (click)="editArtist()"
        icon="edit"
      ></dx-button>
    }
    @if (edit) {
      <dx-button
        type="primary-m"
        label="{{ 'artist.button.save-artist' | transloco }}"
        class="art-submit-button"
        [disabled]="isFormBlocked || artistForm.pristine"
        (click)="saveEditedArtist()"
        [loading]="isLoading()"
      ></dx-button>
      <dx-button
        type="secondary-m"
        label="{{ 'artist.button.cancel' | transloco }}"
        class="art-submit-button cancel-button"
        (click)="cancelEdit()"
      ></dx-button>
    }
  </div>
</dx-modal>
